import {decodeXML} from './BPMNModeler';
import { useNavigate,useSearchParams } from "react-router";
import { createBrowserRouter,useParams,Outlet } from "react-router";
import {useMemo,useEffect,useState,useRef,useCallback } from 'react'
import {useGetProcessFromInstanceQuery,usePublishProcessInstanceDataMutation,useLoadUserQuery,useFileUploadMutation,
		useCompleteProcessStateMutation,databaseViewApi,useAddCommentMutation,useLoadCommentsQuery,
		useGetLoginStatusQuery,useListInstanceFormsQuery,useListInstanceStateDataQuery,useGetMemberAccessQuery,
		useCreateProcessStateEntryMutation} from './redux/databaseView';
import { Stack } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import FormLabel from '@mui/material/FormLabel';
import { TextField, Button } from '@mui/material';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio'
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { createSlice } from "@reduxjs/toolkit";
import {useDispatch, useSelector} from 'react-redux';
import DeleteIcon from "@mui/icons-material/Delete";
import { IconButton } from "@mui/material";
import Link from '@mui/material/Link';
import CircularProgress from '@mui/material/CircularProgress';
import { DateField } from '@mui/x-date-pickers/DateField';
import { TimeField } from '@mui/x-date-pickers/TimeField';
import dayjs from 'dayjs';
import 'dayjs/locale/en-gb';
import {useDropzone} from 'react-dropzone'

export const userFormSlice = createSlice({
  name: "userForm",
  initialState: { name: "", email: ""},
  reducers: {
    updateField: (state, action) => {
		const { field, value } = action.payload;
		state[field] = value; // ✅ immer makes this immutable
		},
	setFieldValid: (state, action)=> {
		const {field, state:value} = action.payload;
//		console.log("result",field,value);
		state["ZZ$valid "+field]=value;
		console.log("ZZ$valid "+field,value);
		},
	resetForm: () => ({ name: "", email: "" }),
	setInitialFormState: (state,action)=>{
//		console.log("reset initial state",action.payload);
		return action.payload;
		},
	removeValidationError:(state,action)=>{
		const field=action.payload;
		if (!state.ZZformErrors)
			return;
		state.ZZformErrors=state.ZZformErrors.filter((x)=>x!==field);
		}
	},
	});

export const { setInitialFormState, updateField, resetForm,setFieldValid,removeValidationError } = userFormSlice.actions;

function isReadOnly(value)
	{
	return !!value&&value!="off";
	}
	

function RETextField({value, defaultFocus, setValue, elementNode,multiline,rows,formReadOnly,...elementProps})
	{
	if (value==null)
		value="";
//	 console.log(formReadOnly);
//	console.log(elementNode.key,readOnly,elementNode);
//	console.log(elementProps);
		
	return (<FormControl required={elementProps.required} fullWidth sx={{textAlign:'left'}} >
				<FormLabel  htmlFor={elementNode.id}>{elementNode.label}</FormLabel>
				<TextField
					id={elementNode.id}
//					placeholder="Wiley Coyote"
					value={value}
					onChange={(x)=>setValue(x.target.value)}
					autoFocus={defaultFocus}
					inputProps={{readOnly:formReadOnly}}
					onFocus={elementProps.handleFocus}
					onBlur={elementProps.handleBlur}
					multiline={!!multiline}
					error={elementProps.error!=null}
					helperText={elementProps.error}
					rows={rows?rows:1}
					fullWidth
					variant="outlined"
					/>
				</FormControl>)
	}
//		              value={value}

/*
				<DateField label="Date" defaultValue={dayjs('2022-04-17')} />
			//adapterLocale
*/

function DatePickerFieldEntity({value,setValue,elementNode,formData,formReadOnly,...elementProps})
	{
	useEffect(()=>{
		if (value==null)
			setValue(dayjs().add(7,'day').toISOString(),false);
		},[value,setValue]);	
	
//	const [value,setValue]=useState("");
//	console.log(elementNode);
	return (
		<FormControl error={!!elementProps.error} sx={{textAlign:'left'}} fullWidth>
			<FormLabel>{elementNode.dateLabel}</FormLabel>
			<LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
				<DemoContainer fullWidth id={elementNode.id} components={['DatePicker']}>
					<DatePicker 
					  value={value?dayjs(value):dayjs().add(7,'day')}
					  disabled={formReadOnly}
					  onChange={(newValue)=>{
						if (newValue) 
							{
							// store as ISO string (serializable)
							setValue(newValue.toISOString());
							} 
						else 
							{
							setValue(null);
							}}}
					  label={elementNode.label} 
					/>
				</DemoContainer>
			</LocalizationProvider>
			{elementProps.error&&
				<FormHelperText>{elementProps.error}</FormHelperText>
			}
		</FormControl>
		);
	}

function RESelect({formData,value,setValue,elementNode,formReadOnly,...elementProps})
	{
	const selectId=elementNode.id??elementNode.key;
	const labelId=selectId+"-label";

	const secondaryValues=useSelector((state)=>{
		if (elementNode.valuesKey)
			{
			return state.userForm[elementNode.valuesKey];
			}
		return 0;
		});

	if (value==null)
		value="";

	function handleChange(e)
		{
		setValue(e.target.value);
		}

	var selectOptions=elementNode.values;
	if (selectOptions==null)
		{
		if (secondaryValues)
			selectOptions=secondaryValues;
		else
			console.log(elementNode);
		}

	return (<FormControl required={elementProps.required} sx={{textAlign:'left'}} fullWidth>
			<FormLabel id={labelId} sx={{textAlign:'left'}}>{elementNode.label}</FormLabel>
			<Select
				labelId={labelId}
				id={selectId}
				displayEmpty
				value={value}
				disabled={formReadOnly}
				error={!!elementProps.error}
				renderValue={(selected)=>{
					if (selected===''||selected==null)
						return <em>None</em>;

					const optionName=selectOptions?.find(o=>o.value===selected);
					return optionName?optionName.label:selected;
					}}
				onChange={handleChange}
				>
				{selectOptions&&selectOptions.map((x)=>{
					return <MenuItem key={x.value} value={x.value}>{x.label}</MenuItem>;
					})}
			</Select>

			{elementProps.error&&
				<FormHelperText error>
					{elementProps.error}
				</FormHelperText>
				}
		</FormControl>);
	}

function RERadioList({formData,value,setValue,elementNode,formReadOnly,...elementProps})
	{
	const forcedOn=useSelector((state)=>{
		if (elementNode.properties?.value)
			{
			return (window.externalEvaluate(state.userForm,elementNode.properties.value)&0xffff);
			}
		return 0;
		});

	const visibleMask=useSelector((state)=>{
		if (elementNode.properties?.visible)
			{
			try
				{
				return (window.externalEvaluate(state.userForm,elementNode.properties.visible)&0xffff);
				}
			catch (e)
				{
				console.log(e);
				}
			}
		return 0xffff;
		});

	function setRadioValue(checked,sectionValue)
		{
		if (!checked)
			return;

		if (isNaN(sectionValue))
			{
			value={};
			value[sectionValue]=true;
			}
		else
			{
			value=sectionValue;
			}

		setValue(value);
		}

	function isRadioSelected(sectionValue)
		{
		if (isNaN(sectionValue))
			{
			if (!value)
				return false;
			return !!value[sectionValue];
			}

		if (forcedOn)
			return !!(forcedOn&sectionValue);

		return value==sectionValue;
		}

	function checkVisible(visibleMask,sectionValue)
		{
		if (isNaN(sectionValue))
			return false;
		else
			return !(visibleMask&sectionValue);
		}

	return (<FormControl
			error={elementProps?.error!=null}
			required={elementProps?.required}
			sx={{width:'100%'}}
			margin="dense"
			>
			<FormLabel style={{textAlign:'left'}} htmlFor={elementNode.id}>
				{elementNode.label}
			</FormLabel>
			<FormGroup sx={{
				border:elementProps.error?'1px solid':'1px solid transparent',
				borderColor:elementProps.error?'error.main':'transparent',
				borderRadius:1,
				p:1
				}}>
				{elementNode.values.map((x,idx)=>{
					return (<FormControlLabel
						key={idx}
						control={<Radio
							onChange={(evt)=>setRadioValue(evt.target.checked,x.value)}
							checked={isRadioSelected(x.value)}
							/>}
						disabled={formReadOnly||!!forcedOn||checkVisible(visibleMask,x.value)}
						label={x.label}
						/>);
					})}
			</FormGroup>

			{elementProps?.error&&(
				<FormHelperText>{elementProps.error}</FormHelperText>
				)}
		</FormControl>);
	}

function RECheckList({formData,value,setValue,elementNode,formReadOnly,...elementProps})
	{
	const forcedOn=useSelector((state)=>{
		if (elementNode.properties?.value)
			{
			try 
				{
				return (window.externalEvaluate(state.userForm,elementNode.properties.value)&0xffff);
				}
			catch (e)
				{
				console.log(e);
				}
			}
		return 0;
		});

	const visibleMask=useSelector((state)=>{
		if (elementNode.properties?.visible)
			{
			try 
				{
				return (window.externalEvaluate(state.userForm,elementNode.properties.visible)&0xffff);
				}
			catch (e)
				{
				console.log(e);
				}
			}
		return 0xffff;
		});

	function setCheckListValue(checked,sectionValue,index)
		{
		if (isNaN(sectionValue))
			{
			if (value==null)
				value={};
			else
				value={...value};
			value[sectionValue]=checked;
			}
		else
			{
			if (checked)
				value|=sectionValue;
			else
				value&=(~sectionValue);
			}
		setValue(value);
		}

	function checkValue(index,sectionValue)
		{
		if (isNaN(sectionValue))
			{
			if (!value)
				return false;
			return !!value[sectionValue];
			}
		return (value|forcedOn)&sectionValue;
		}

	function checkVisible(visibleMask,sectionValue)
		{
		if (isNaN(sectionValue))
			return false;
		else
			return !(visibleMask&sectionValue);
		}

	return (<FormControl error={!!elementProps.error} fullWidth>
			<FormLabel style={{textAlign:'left'}} htmlFor={elementNode.id}>
				{elementNode.label}
			</FormLabel>

			<FormGroup sx={{
				width:'100%',
				border:elementProps.error?'1px solid':'1px solid transparent',
				borderColor:elementProps.error?'error.main':'transparent',
				borderRadius:1,
				p:1
				}} margin="dense">
				
				{elementNode.values.map((x,idx)=>{
					return (<FormControlLabel
						key={idx}
						control={<Checkbox
							onChange={(evt)=>setCheckListValue(evt.target.checked,x.value,idx)}
							checked={checkValue(idx,x.value)}
							/>}
						disabled={formReadOnly||checkVisible(visibleMask,x.value)}
						label={x.label}
						/>);
					})}
			</FormGroup>

			{elementProps.error&&
				<FormHelperText>{elementProps.error}</FormHelperText>
				}
		</FormControl>);
	}
	
function RECheckbox({value,setValue,elementNode,formReadOnly,...elementProps})
	{
	return (<FormControl error={!!elementProps.error} fullWidth>
			<FormGroup sx={{width:'100%'}} margin="dense">
				<FormControlLabel
					control={<Checkbox
						disabled={formReadOnly}
						onChange={(evt)=>setValue(evt.target.checked)}
						checked={!!value}
						/>}
					label={elementNode.label}
					/>
			</FormGroup>

			{elementProps.error&&
				<FormHelperText>{elementProps.error}</FormHelperText>
				}
		</FormControl>);
	}
	
	
const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});


function REFileUpload({value,setValue,elementNode,formData,formReadOnly,...elementProps})
	{
	function processFile(files)
		{
		if (!formData.current.ZZfiles)
			formData.current={...formData.current,ZZfiles:{}};

		formData.current.ZZfiles={...formData.current.ZZfiles,[elementNode.properties.fileTable]:files};

		Array.from(files).some((fileEntry)=>{
			setValue(fileEntry.name);
			return true;
			});
		}

	return (<FormControl error={!!elementProps.error} 
				sx={{
					width:'100%',
					border:elementProps.error?'1px solid':'1px solid transparent',
					borderColor:elementProps.error?'error.main':'transparent',
					borderRadius:1,
					p:1
					}} 
				fullWidth>
			<Button
				component="label"
				role={undefined}
				variant="contained"
				tabIndex={-1}
				disabled={formReadOnly}
				startIcon={<CloudUploadIcon />}
				>
				Upload files
				<VisuallyHiddenInput
					type="file"
					onChange={(event)=>processFile(event.target.files)}
					multiple
					/>
			</Button>

			<div>{value}</div>

			{elementProps.error&&
				<FormHelperText>{elementProps.error}</FormHelperText>
				}
		</FormControl>);
	}	
function RETable({value, formData, elementNode,formReadOnly})
	{
	  const inDelete=useRef(0);
	  const dispatch=useDispatch();
	  var rows=(!value)?[]:value;
	  const key=elementNode.properties?.tableKey;
	  var data=useSelector((state)=>(key)?state.userForm[key]:null);
	  if (!key)
		return;
	  rows=formData.current[key];
	  if (!rows)
		rows=[];

	async function deleteIDX(idx)
		{
		if (inDelete.current)
			return;

		inDelete.current=1;
		try
			{
			var currentList=[...formData.current[key]];
			currentList.splice(idx,1);
			formData.current[key]=currentList;
			await dispatch(updateField({field:key,value:currentList}));
			}
		finally
			{
			inDelete.current=0;
			}
		}

//	  console.log(formData.current,library,data);
	  return (
			<TableContainer sx={{maxHeight:400,overflowY:'auto'}} component={Paper}>
			  <Table sx={{ width: '100%',minHeight:200}} aria-label="simple table">
				<TableHead sx={{position:'sticky',top:0,backgroundColor:'white'}}>
				  <TableRow>
					{
					elementNode.columns.map((x)=>
						{
						return <TableCell key={x.key}>{x.label}</TableCell>
						})
					}				
				  </TableRow>
				</TableHead>
				<TableBody>
				  {rows.map((row,idx) => {
				  return (
					<TableRow
					  key={"row"+idx}
					  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
					>
					{
					
					elementNode.columns.map((x)=>{
						if (x.key=="delete")
							return (<TableCell key={x.key} component="th" scope="row">
										<IconButton color="error" 
											disabled={formReadOnly}
											onClick={()=>deleteIDX(idx)}>
											<DeleteIcon />
										</IconButton>
									</TableCell>)
						if (x.key=="_name")
							return (<TableCell key={x.key} component="th" scope="row">
									<Link target="_blank" href={"/fileViewer/"+row.ref+"/"+row[x.key]}>{row[x.key]}</Link>
									</TableCell>)							
						return (<TableCell key={x.key} component="th" scope="row">
							{
							row[x.key]
							}
						  </TableCell>)
						})
					}
					</TableRow>
				  )})}
				</TableBody>
			  </Table>
			</TableContainer>
		  );

	}

function evalCondition(data,condition)
	{
	if (condition.startsWith('=')) 
		condition=condition.slice(1);
	var result=window.externalEvaluate(data,condition)
	return result;
	}

function useCondition(control, condition, key, defaultValue)
	{
	//console.log(control);//just for quick debugging
	return useSelector((state)=>{
		if (!condition)
			return defaultValue;
		return evalCondition(state[key],condition);
		});
	}
	
export function RELoadingButton({elementNode,clickFunction,formReadOnly,formData})
	{
//	console.log(elementNode);
	const [loading, setLoading] = useState(false);
	async function doClick(e)
		{
		e.stopPropagation();
		setLoading(true);
		try 
			{
			console.log(formData.current);
			await clickFunction({id:elementNode.id,label:elementNode.label,tableKey:elementNode.properties?.assocTable,action:elementNode.properties?.action},elementNode.properties?.validationScope);
			}
		finally 
			{
			setLoading(false);	
			}
		}
		
	return <Button  
				style={{minWidth:200}}
				onClick={doClick} 
				disabled={loading||formReadOnly}	
				variant="contained">
			<Stack direction="row" alignItems="center" spacing={1}> <span>{elementNode.label}</span>
			{loading&&<div><CircularProgress size={16} color="inherit" /></div>}	
			</Stack>
			</Button>
	}

function ensureFourDigits(num)
	{
	return String(num).padStart(4,'0');
	}

function checkErrors(data,elementNode)
	{
	if (!elementNode.key)
		return false;
	const value=data[elementNode.key];
	const validate=elementNode.validate;
	if (!validate?.required)
		return false;
	if (validate.required&&(value==null||String(value).trim()===""))
		return "Required value not selected or empty";
	else if (validate.pattern&&(!String(value).match(validate.pattern)))
		return "Required value must match pattern: "+validate.pattern;
	else if (validate.minLength&&(!value||value.length<validate.minLength))
		return "Required value must be longer than "+value.length+" characters";
	else if (validate.maxLength&&(!value||value.length>validate.maxLength))
		return "Required value must be longer than "+value.length+" characters";
	return false;
	}

function validationElementHidden(data,elementNode)
	{
	if (!elementNode.conditional?.hide)
		return false;

	try
		{
		return !!evalCondition(data,elementNode.conditional.hide);
		}
	catch (e)
		{
		console.log(e);
		return false;
		}
	}

function validateElement(data,elementNode,errors)
	{
	if (!elementNode.key)
		return;
	const error=checkErrors(data,elementNode);
	if (error)
		errors.push(elementNode.key);
	}

function validateElements(currentSchema,data,mode,errors,insideScope=false,currentLevel=null)
	{
	currentSchema.components?.forEach((elementNode)=>{
		if (validationElementHidden(data,elementNode))
			return;

		if (currentLevel&&elementNode.properties?.level&&(currentLevel>elementNode.properties.level))
			return;

		const scope=elementNode.properties?.validationScope??null;

		if (mode==null)
			{
			// Normal validation ignores named scopes
			if (scope!=null)
				return;

			validateElement(data,elementNode,errors);

			if (elementNode.components)
				validateElements(elementNode,data,mode,errors,false,elementNode.properties?.level??currentLevel);
			return;
			}

		if (insideScope)
			{
			// Null children inherit the selected scope; another named scope is a new boundary
			if (scope!=null&&scope!==mode)
				return;

			validateElement(data,elementNode,errors);

			if (elementNode.components)
				validateElements(elementNode,data,mode,errors,true,elementNode.properties?.level??currentLevel);
			return;
			}

		// Searching for requested scope
		if (scope===mode)
			{
			validateElement(data,elementNode,errors);

			if (elementNode.components)
				validateElements(elementNode,data,mode,errors,true,elementNode.properties?.level??currentLevel);
			return;
			}

		// Search through null-scoped containers
		if (scope==null&&elementNode.components)
			validateElements(elementNode,data,mode,errors,false,elementNode.properties?.level??currentLevel);
		});
	}

function validateSchema(schema,data,mode=null,currentLevel=null)
	{
	const errors=[];
	validateElements(schema,data,mode,errors,mode!=null,currentLevel);
	return errors;
	}

function REGroupFile({formData,clickFunction,elementNode,formReadOnly})
	{
	const dispatch=useDispatch();
	const isHidden=useCondition(elementNode.key,elementNode.conditional?.hide,"userForm",false);

	const onDrop=useCallback(acceptedFiles=>{
		var fileTable=elementNode.properties.fileTable;
		console.log(acceptedFiles,fileTable);
//		formData.current={...formData.current,[elementNode.key+"_file"]:acceptedFiles};
		if (!formData.current.ZZfiles)
			formData.current={...formData.current,ZZfiles:{}};

		formData.current.ZZfiles={...formData.current.ZZfiles,[fileTable]:acceptedFiles};
		console.log(formData.current);
		Array.from(acceptedFiles).some((fileEntry)=>{
			if (elementNode.properties.fileDisplay)
				dispatch(updateField({field:elementNode.properties.fileDisplay,value:fileEntry.name}));
			return true;
			});
		},[elementNode,formData,dispatch]);

	const {getRootProps,getInputProps,isDragActive}=useDropzone({
		onDrop,
		noClick:true,
		noKeyboard:true,
		disabled:formReadOnly
		});

	if (isHidden)
		return null;

	return (<div style={{margin:4,width:'100%'}} {...getRootProps()}>
		<input {...getInputProps()} />
		<FormControl sx={{border:"1px solid black",p:1,minHeight:200}} fullWidth>
			<Stack direction="row" spacing={2}>
				<span style={{width:'100%'}}>{elementNode.label}</span>
				<span style={{width:'100%'}}>Drop Zone</span>
			</Stack>
			{!isDragActive&&<FormGroup>
				<RenderDocument formData={formData} clickFunction={clickFunction} schema={elementNode}/>
			</FormGroup>}
			{isDragActive&&<p>Drop the files here ...</p>}
		</FormControl>
	</div>);
	}

function REGroup({formData,clickFunction,elementNode,formReadOnly,viewOptions})
	{
	const isHidden=useCondition(elementNode.key,elementNode.conditional?.hide,"userForm",false);

	if (elementNode?.properties?.type==="file")
		return <REGroupFile formData={formData} clickFunction={clickFunction} elementNode={elementNode} formReadOnly={formReadOnly}/>;

	if (isHidden)
		return null;

	var readOnly=isReadOnly(elementNode.properties?.readOnly)||isReadOnly(viewOptions?.readOnly);
	return (<div style={{margin:4,width:'100%'}}>
		<FormControl sx={{border:"1px solid black",p:1,minHeight:200}} fullWidth>
			<span style={{width:'100%'}}>{elementNode.label}</span>
			<FormGroup>
				<RenderDocument formData={formData} clickFunction={clickFunction} schema={elementNode} viewOptions={{level:elementNode.properties?.level,readOnly}}/>
			</FormGroup>
		</FormControl>
	</div>);
	}

function RenderElement({elementNode,formData,viewOptions,clickFunction,processClick,updateIfNeeded,updatePrefix})
	{
	const dispatch=useDispatch();
	const value=useSelector((state)=>state.userForm[elementNode.key]??null);
	const validationError=useSelector((state)=>{
		if (!elementNode.key)
			return false;
		if (!state.userForm["ZZformErrors"]||!state.userForm["ZZformErrors"].length)
			return false;
		return state.userForm["ZZformErrors"].includes(elementNode.key);
		});

	const [focus,setFocus]=useState(2);
	const [error,setError]=useState(null);
	const isHidden=useCondition(elementNode.key,elementNode.conditional?.hide,"userForm",false);

	useEffect(()=>{
		setError(validationError?"Element failed validation":null);
		},[validationError]);

	function handleFocus()
		{
		setFocus(true);
		}

	function handleBlur()
		{
		setFocus(false);
		}

	useEffect(()=>{
		},[value]);

	if (viewOptions?.level&&elementNode.properties?.level&&(viewOptions.level>elementNode.properties.level))
		return null;

	if (isHidden)
		return null;

	if (elementNode.key!=null)
		formData.current={...formData.current,[elementNode.key]:value};

	function setValue(value,userChange=true)
		{
		if (elementNode.key==null)
			return;
		formData.current[elementNode.key]=value;
		if (userChange)
			{
			if (elementNode?.properties?.processPrefix&&!!value&&value!="No Entry")
				{
				updateIfNeeded("ZZprocessPrefix",value);
				updatePrefix(value);
				}
			else if (elementNode?.properties?.assignment)
				updateIfNeeded("ZZassignment",value);
			else if (elementNode?.properties?.processDue)
				updateIfNeeded("ZZprocessDue",value);
			else if (elementNode?.properties?.taskDue)
				updateIfNeeded("ZZtaskDue",value);
			}
		var error=checkErrors(formData.current,elementNode);
		setError(error?error:null);
		dispatch(updateField({field:elementNode.key,value}));
		if (!error)
			dispatch(removeValidationError(elementNode.key));
		}

	var elementProps={
		required:elementNode.validate?.required,
		formReadOnly:isReadOnly(formData.current.readOnly)||isReadOnly(elementNode.readonly)||isReadOnly(viewOptions?.readOnly),
		value,
		setValue,
		elementNode,
		formData,
		handleBlur,
		handleFocus,
		error
		};

	switch (elementNode.type)
		{
		case 'textfield':
			if (!formData.current.defaultFocus)
				formData.current.defaultFocus=elementNode.id;
			return (<RETextField {...elementProps} defaultFocus={formData.current.defaultFocus==elementNode.id}/>);
		case 'number':
			return (<RETextField {...elementProps} defaultFocus={formData.current.defaultFocus==elementNode.id}/>);
		case 'datetime':
			return (<DatePickerFieldEntity {...elementProps}/>);
		case 'textarea':
			return (<RETextField {...elementProps} multiline={true} rows={6}/>);
		case 'spacer':
			return (<FormControl fullWidth/>);
		case 'checkbox':
			return (<RECheckbox {...elementProps}/>);
		case 'button':
			return (<RELoadingButton {...elementProps} clickFunction={processClick}/>);
		case 'select':
			return (<RESelect {...elementProps}/>);
		case 'checklist':
			return (<RECheckList {...elementProps}/>);
		case 'filepicker':
			return (<REFileUpload {...elementProps}/>);
		case 'table':
			return (<RETable {...elementProps}/>);
		case 'radio':
			return (<RERadioList {...elementProps}/>);
		case 'group':
			return (<REGroup {...elementProps} clickFunction={clickFunction} viewOptions={viewOptions}/>);
		default:
			console.log(elementNode);
			return (<FormControl fullWidth>{elementNode.type}</FormControl>);
		}
	}

function RenderRow({schema,rowName,formData,viewOptions,clickFunction,processClick,updateIfNeeded,updatePrefix})
	{
	return (<Stack style={{alignText:'left',alignItems:'center'}} direction="row" spacing={2}>
		{schema.components.map((x)=>{
			if (x.layout.row!=rowName)
				return null;
			return (<RenderElement
				key={x.id}
				elementNode={x}
				formData={formData}
				viewOptions={viewOptions}
				clickFunction={clickFunction}
				processClick={processClick}
				updateIfNeeded={updateIfNeeded}
				updatePrefix={updatePrefix}
				/>);
			})}
	</Stack>);
	}

export function RenderDocument({schema,clickFunction,formData,viewOptions})
	{
	const dispatch=useDispatch();

	if (schema==null)
		return <div><h1>No form Found</h1></div>;

	async function processClick(button,scope)
		{
		const errors=validateSchema(schema,formData.current,scope,viewOptions?.level);
		dispatch(updateField({field:"ZZformErrors",value:errors}));
		if (errors.length)
			return;
		await clickFunction(button);
		}

	function updateIfNeeded(field,value)
		{
		if (formData.current[field]==value)
			return;
		formData.current[field]=value;
		dispatch(updateField({field,value}));
		}

	async function updatePrefix(value)
		{
		var result=await clickFunction({id:0,label:"changePrefix",value});
		if (result)
			updateIfNeeded("projectNumber",value+ensureFourDigits(result));
		}

	var processed={};
	return (<Stack sx={{pl:4,pr:4,pb:4}} spacing={2}>{schema.components.map((x)=>{
		if (!processed[x.layout.row])
			{
			processed[x.layout.row]=true;
			return (<RenderRow
				key={x.layout.row}
				schema={schema}
				rowName={x.layout.row}
				formData={formData}
				viewOptions={viewOptions}
				clickFunction={clickFunction}
				processClick={processClick}
				updateIfNeeded={updateIfNeeded}
				updatePrefix={updatePrefix}
				/>);
			}
		return null;
		})}</Stack>);
	}
